import { handleSystemErrorReport } from '@mb/lib/utils';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useAPICallStateHandler } from './customHooks';
import { definedTranslation } from '../../../pages/ProductSearch/i18n';
import { setSnackbarInfo } from '../redux/sliceCreators/commonSlice';
import { SnackbarStatusEnum } from '../types';

export const useSwitchCurrentUserProject = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { state, setState } = useAPICallStateHandler();

  const labels = {
    success: intl?.formatMessage(
      definedTranslation.projectMessages.projectUpdated,
    ),
    error: intl?.formatMessage(
      definedTranslation.projectMessages.errorProjectSet,
    ),
  };

  const displayNotification = async (showSnackbar = true) => {
    try {
      if (showSnackbar) {
        dispatch(
          setSnackbarInfo({
            isOpen: true,
            message: labels.success,
            status: SnackbarStatusEnum.SUCCESS,
          }),
        );
      }
      setState({ isLoading: false });
    } catch (error) {
      dispatch(
        setSnackbarInfo({
          isOpen: true,
          message: error.message ?? labels.error,
          status: SnackbarStatusEnum.DANGER,
        }),
      );
      handleSystemErrorReport(
        `Error in useSwitchCurrentUserProject: ${error.message}`,
        'useSwitchCurrentUserProject',
      );
      setState({ isLoading: false, error });
    }
  };

  return { ...state, displayNotification };
};

export default useSwitchCurrentUserProject;
